module.exports = __webpack_public_path__ + "images/assets/1f6336ca09d30b181f1304c0d67fd914.svg";